<template>
  <el-drawer
    title="批量导入国际化语言"
    :visible.sync="dialogVisible"
    :wrapperClosable="false"
    direction="rtl"
    size="580px"
    append-to-body
    @close="resetForm"
  >
    <div class="drawer-body">
      <div class="import-tip">
        <div class="tip-title">提示</div>
        <ol class="tip-list">
          <li>1.列的顺序请严格按照模板文件排列</li>
          <li>2.文件格式须为xlsx、xls格式</li>
          <li v-if="pageDeep === 1">3.一级页面需在下方补充图标后再点击确定</li>
          <li>
            {{ pageDeep === 1 ? 4 : 3 }}.导入模板下载：<el-button
              type="text"
              class="download-link"
              @click="downloadTemplate"
              >导入模板.xlsx</el-button
            >
          </li>
        </ol>
      </div>
      <div class="upload-row">
        <span class="upload-label"
          ><span class="required">*</span>上传Excel文件：</span
        >
        <el-upload
          action="#"
          :show-file-list="false"
          :auto-upload="false"
          accept=".xlsx,.xls"
          :on-change="handleFileChange"
        >
          <el-button type="primary" icon="el-icon-upload2">上传文件</el-button>
        </el-upload>
      </div>
      <div v-if="fileName" class="file-name">{{ fileName }}</div>

      <template v-if="pageDeep === 1">
        <div class="icon-section-title">图标（将应用于所有导入语言）</div>
        <el-form label-width="100px" label-suffix=":" class="icon-form">
          <el-form-item label="浅色图标">
            <div class="icon-area">
              <div class="fc ac">
                <div>主图标</div>
                <UploadImg
                  :acceptType="['png']"
                  :limWidth="96"
                  :limHeight="96"
                  v-model="iconForm.icon"
                />
              </div>
              <div class="mhor10 fc ac">
                <div>副图标</div>
                <UploadImg
                  :acceptType="['png']"
                  :limWidth="96"
                  :limHeight="96"
                  v-model="iconForm.sicon"
                />
              </div>
            </div>
            <p class="hint">提示：尺寸 96*96，png格式</p>
          </el-form-item>
          <el-form-item label="深色图标">
            <div class="icon-area">
              <div class="fc ac">
                <div>主图标</div>
                <UploadImg
                  :acceptType="['png']"
                  :limWidth="96"
                  :limHeight="96"
                  v-model="iconForm.darkIcon"
                />
              </div>
              <div class="mhor10 fc ac">
                <div>副图标</div>
                <UploadImg
                  :acceptType="['png']"
                  :limWidth="96"
                  :limHeight="96"
                  v-model="iconForm.darkSicon"
                />
              </div>
            </div>
            <p class="hint">提示：尺寸 96*96，png格式</p>
          </el-form-item>
        </el-form>
      </template>

      <el-form label-width="140px" label-suffix=":" class="sync-form">
        <el-form-item label="一键同步所有语言">
          <el-radio-group v-model="syncType">
            <el-radio
              size="small"
              v-for="item in booleanList"
              :key="item.key"
              :label="item.key"
              :disabled="item.key === 1"
              >{{ item.value }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <div class="drawer-footer">
      <el-button type="primary" @click="handleConfirm" :loading="submitting"
        >确定</el-button
      >
      <el-button @click="dialogVisible = false">取消</el-button>
    </div>
  </el-drawer>
</template>

<script>
import XLSX from "xlsx";
import { mapGetters } from "vuex";
import UploadImg from "@/components/UploadImg.vue";
import { booleanList } from "@/common/constant/constant.js";
import { batchInsertGlobalMarketPage } from "../indexServe";

export default {
  components: { UploadImg },
  props: {
    isShow: { type: Boolean, default: false },
    pageId: { type: [String, Number], default: "" },
    // 页面深度：1=一级页面（需要图标）其它=二级页面
    pageDeep: { type: [String, Number], default: "" },
    // 当前页面已存在的国际化语言列表（完整列表）
    existingList: { type: Array, default: () => [] },
  },
  computed: {
    ...mapGetters(["languageList"]),
    dialogVisible: {
      get() {
        return this.isShow;
      },
      set(val) {
        this.$emit("update:isShow", val);
      },
    },
  },
  data() {
    return {
      booleanList,
      fileName: "",
      fileHeader: [],
      parsedRows: null,
      submitting: false,
      syncType: 0,
      iconForm: {
        icon: "",
        sicon: "",
        darkIcon: "",
        darkSicon: "",
      },
    };
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.resetForm();
        this.$store.dispatch("updateLanguageList");
      }
    },
  },
  methods: {
    resetForm() {
      this.fileName = "";
      this.fileHeader = [];
      this.parsedRows = null;
      this.submitting = false;
      this.syncType = 0;
      this.iconForm = {
        icon: "",
        sicon: "",
        darkIcon: "",
        darkSicon: "",
      };
    },
    /**
     * 下载模板：A列预填系统支持的全部语言，B列为空
     */
    async downloadTemplate() {
      let langs = this.languageList;
      if (!langs || !langs.length) {
        langs = await this.$store.dispatch("updateLanguageList");
      }
      if (!langs || !langs.length) {
        this.$message.warning("语言列表加载失败，请稍后重试");
        return;
      }
      const header = ["语言", "翻译名称"];
      const data = [header];
      langs.forEach((item) => {
        data.push([item.languageName, ""]);
      });
      const sheet = XLSX.utils.aoa_to_sheet(data);
      sheet["!cols"] = [{ wch: 20 }, { wch: 30 }];
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, sheet, "sheet1");
      XLSX.writeFile(wb, "导入模板.xlsx");
    },
    async handleFileChange(file) {
      if (!file) return;
      const rawFile = file.raw || file;
      const name = file.name || rawFile.name || "";
      const ext = name.substring(name.lastIndexOf(".") + 1).toLowerCase();
      if (ext !== "xlsx" && ext !== "xls") {
        this.$message.error("文件格式须为xlsx、xls格式");
        return;
      }
      this.fileName = name;
      if (!this.languageList || !this.languageList.length) {
        await this.$store.dispatch("updateLanguageList");
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const wb = XLSX.read(data, { type: "array" });
          const firstSheetName = wb.SheetNames[0];
          const sheet = wb.Sheets[firstSheetName];
          const rows = XLSX.utils.sheet_to_json(sheet, {
            header: 1,
            defval: "",
            blankrows: false,
          });
          const { header, list } = this.buildRows(rows);
          this.fileHeader = header;
          this.parsedRows = list;
        } catch (err) {
          console.error(err);
          this.fileHeader = [];
          this.parsedRows = null;
          this.$message.error("文件解析失败，请检查文件内容");
        }
      };
      reader.readAsArrayBuffer(rawFile);
    },
    buildRows(rows) {
      if (!rows || !rows.length) return { header: [], list: [] };
      const header = (rows[0] || []).map((v) => String(v || "").trim());
      const list = [];
      for (let i = 1; i < rows.length; i++) {
        const row = rows[i] || [];
        const languageName = String(row[0] == null ? "" : row[0]).trim();
        const pageNameLang = String(row[1] == null ? "" : row[1]).trim();
        if (!languageName && !pageNameLang) continue;
        list.push({ languageName, pageNameLang });
      }
      return { header, list };
    },
    /**
     * 校验 + 提交
     * 1. 未上传文件 → 请先上传文件
     * 2. 列结构 → 文件格式不符
     * 3. 内容缺失 → 部分语言翻译内容为空
     * 4. 文件内重复语言 → 文件中存在重复语言
     * 5. 与已有语言冲突 → 弹窗跳过/覆盖
     * 一级页面：额外校验图标必填
     */
    async handleConfirm() {
      if (!this.fileName || !this.parsedRows) {
        this.$message.warning("请先上传文件");
        return;
      }
      if (this.fileHeader[0] !== "语言" || this.fileHeader[1] !== "翻译名称") {
        this.$message.warning("文件格式不符，请重新提交");
        return;
      }
      const rawList = this.parsedRows;
      if (!rawList.length) {
        this.$message.warning("请先上传文件");
        return;
      }
      const hasMissing = rawList.some(
        (item) => item.languageName && !item.pageNameLang,
      );
      if (hasMissing) {
        this.$message.warning("部分语言翻译内容为空，请重新提交");
        return;
      }
      // 一级页面图标校验
      if (this.pageDeep === 1) {
        const { icon, sicon, darkIcon, darkSicon } = this.iconForm;
        if (!icon || !sicon || !darkIcon || !darkSicon) {
          this.$message.warning(
            "请上传完整的浅色主图标、浅色副图标、深色主图标、深色副图标",
          );
          return;
        }
      }
      const nameToType = {};
      (this.languageList || []).forEach((l) => {
        nameToType[l.languageName] = l.languageType;
      });
      const importList = [];
      rawList.forEach((item) => {
        if (!item.languageName || !item.pageNameLang) return;
        const language = nameToType[item.languageName];
        if (!language) return;
        importList.push({
          language,
          languageName: item.languageName,
          pageNameLang: item.pageNameLang,
        });
      });
      if (!importList.length) {
        this.$message.warning("没有可导入的有效数据，请检查文件");
        return;
      }
      const langCount = {};
      importList.forEach((item) => {
        langCount[item.language] = (langCount[item.language] || 0) + 1;
      });
      const duplicateInFile = Object.keys(langCount).some(
        (key) => langCount[key] > 1,
      );
      if (duplicateInFile) {
        this.$message.warning("文件中存在重复语言，请重新提交");
        return;
      }
      const existMap = {};
      (this.existingList || []).forEach((item) => {
        existMap[item.language] = item;
      });
      const conflictItems = importList.filter(
        (item) => existMap[item.language],
      );
      if (conflictItems.length) {
        const conflictNames = conflictItems
          .map((item) => item.languageName)
          .join("、");
        try {
          const action = await this.confirmConflict(conflictNames);
          if (action === "skip") {
            // 跳过：后端根据 importType=1 跳过已存在
            await this.submitImport(importList, 1);
          } else if (action === "cover") {
            // 覆盖：后端根据 importType=2 覆盖已存在
            await this.submitImport(importList, 2);
          }
        } catch (e) {
          // 取消操作
        }
      } else {
        await this.submitImport(importList, 1);
      }
    },
    confirmConflict(conflictNames) {
      return new Promise((resolve, reject) => {
        this.$msgbox({
          title: "提示",
          message: `以下语言已存在：${conflictNames}`,
          showCancelButton: true,
          confirmButtonText: "覆盖",
          cancelButtonText: "跳过",
          distinguishCancelAndClose: true,
          type: "warning",
        })
          .then(() => resolve("cover"))
          .catch((action) => {
            if (action === "cancel") {
              resolve("skip");
            } else {
              reject(action);
            }
          });
      });
    },
    /**
     * 调用批量接口 /cmsPage/desc/batchInsert
     * @param {Array} list 待导入列表
     * @param {Number} importType 1=跳过已有语言 2=覆盖已有语言
     */
    async submitImport(list, importType) {
      if (!list || !list.length) {
        this.$message.info("没有可导入的数据");
        return;
      }
      this.submitting = true;
      try {
        const descList = list.map((item) => {
          const desc = {
            language: item.language,
            pageNameLang: item.pageNameLang,
          };
          if (this.pageDeep === 1) {
            desc.icon = this.iconForm.icon;
            desc.sicon = this.iconForm.sicon;
            desc.darkIcon = this.iconForm.darkIcon;
            desc.darkSicon = this.iconForm.darkSicon;
          }
          return desc;
        });
        const res = await batchInsertGlobalMarketPage({
          pageId: this.pageId,
          syncType: this.syncType,
          importType,
          descList,
        });
        if (res === false || res == null) {
          return;
        }
        this.$message.success("批量导入成功");
        this.dialogVisible = false;
        this.$emit("refresh");
      } catch (err) {
        console.error(err);
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer-body {
  padding: 0 20px 20px;
}

.drawer-footer {
  padding: 12px 20px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}

.import-tip {
  background: #fff;

  .tip-title {
    font-weight: 600;
    margin-bottom: 6px;
  }

  .tip-list {
    padding-left: 20px;
    margin: 0 0 16px 0;
    line-height: 26px;
    color: #606266;
  }

  .download-link {
    padding: 0;
    margin-left: 4px;
  }
}

.upload-row {
  display: flex;
  align-items: center;
  margin-top: 10px;

  .upload-label {
    width: 140px;
    text-align: right;
    margin-right: 8px;
    color: #606266;
  }

  .required {
    color: #f56c6c;
    margin-right: 4px;
  }
}

.file-name {
  margin-left: 128px;
  margin-top: 8px;
  color: #606266;
  word-break: break-all;
}

.icon-section-title {
  margin-top: 30px;
  margin-bottom: 10px;
  color: #606266;
}

.icon-form {
  .icon-area {
    display: flex;
  }

  .hint {
    font-size: 13px;
    color: #ccc;
    margin: 0;
  }
}

.sync-form {
  margin-top: 20px;
}
</style>
